
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class RiskRatingService {

    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    get() {
        return this.http.get(`setups/risk/risk-rating`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    save(body) {
        return this.http.post(`setups/risk/risk-rating`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    update(body, id: number) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/risk/risk-rating/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getProducts() {
        return this.http.get(`setups/product-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}